export default "__VITE_ASSET__BVQwl5dv__"